import Vue from 'vue'
import {
  Pagination,
  Dialog,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Button,
  Popover,
  Checkbox,
  CheckboxGroup,
  Radio,
  RadioGroup,
  Table,
  TableColumn,
  DatePicker,
  TimePicker,
  Tabs,
  TabPane,
  Col,
  Row,
  Container,
  Menu,
  MenuItem,
  Header,
  Aside,
  Alert,
  Main,
  Loading,
  Message,
  MessageBox,
  Notification,
  Cascader,
  CascaderPanel,
  Tag,
  Breadcrumb,
  BreadcrumbItem,
  Carousel,
  CarouselItem,
  Card,
  transfer,
  Switch,
  Tooltip,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Scrollbar,
  Upload,
  Autocomplete,
  Divider,
  Link,
  InputNumber,
  Tree,
} from 'element-ui'

const elements = {
  Pagination,
  Dialog,
  Form,
  FormItem,
  Input,
  Select,
  Option,
  Button,
  Popover,
  Radio,
  RadioGroup,
  Checkbox,
  CheckboxGroup,
  Table,
  TableColumn,
  DatePicker,
  Tabs,
  TabPane,
  Col,
  Row,
  Container,
  Menu,
  MenuItem,
  Header,
  Aside,
  Alert,
  Main,
  Cascader,
  CascaderPanel,
  Tag,
  Breadcrumb,
  BreadcrumbItem,
  Carousel,
  CarouselItem,
  Card,
  transfer,
  Switch,
  Tooltip,
  Dropdown,
  DropdownMenu,
  DropdownItem,
  Scrollbar,
  Upload,
  Autocomplete,
  Divider,
  Link,
  InputNumber,
  TimePicker,
  Tree,
}

Object.keys(elements).forEach((component) => {
  Vue.use(elements[component])
})

Vue.use(Loading.directive)

Vue.prototype.$loading = Loading.service
Vue.prototype.$msgbox = MessageBox
Vue.prototype.$alert = MessageBox.alert
Vue.prototype.$confirm = MessageBox.confirm
Vue.prototype.$prompt = MessageBox.prompt
Vue.prototype.$notify = Notification
Vue.prototype.$message = Message
